// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3UceN","itemTitle":"ClientEmergencyInfo_itemTitle__3-71W","itemText":"ClientEmergencyInfo_itemText__2FRm-"};